import {
  LayoutOptions,
  HeaderBlockType,
  processLayoutOptions,
  Shared,
} from "@kameleon-core/lib";
import { InferProps } from "prop-types";

enum Alignment {
  left = "left",
  center = "center",
  right = "right",
}

export const layoutOptions = {
  ...LayoutOptions.BackgroundColor,
  ...{
    menuAlignment: LayoutOptions.Options(Alignment),
    _positionAbsolute: LayoutOptions.Boolean,
  },
};

const layoutProps = processLayoutOptions(layoutOptions);
export type LayoutProps = InferProps<typeof layoutProps>;

export type LogoProp = {
  invert?: boolean | undefined;
} & Shared.Props.MediaProp;

export type NavigationType = {
  logo: LogoProp;
} & HeaderBlockType<LayoutProps>;
